export const FileUploadIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={19.2} height={24} {...props}>
        <path
            fill="#5078e1"
            d="M2.7 0A2.7 2.7 0 0 0 0 2.7v18.6A2.7 2.7 0 0 0 2.7 24h13.8a2.7 2.7 0 0 0 2.7-2.7V9.6h-6.9a2.7 2.7 0 0 1-2.7-2.7V0Zm8.7.527V6.9a.9.9 0 0 0 .9.9h6.373ZM9.6 10.8a.9.9 0 0 1 .636.264l2.4 2.4a.9.9 0 1 1-1.273 1.273l-.864-.864V17.1a.9.9 0 1 1-1.8 0v-3.227l-.864.864a.9.9 0 1 1-1.273-1.273l2.4-2.4A.9.9 0 0 1 9.6 10.8Zm-3.9 8.4h7.8a.9.9 0 1 1 0 1.8H5.7a.9.9 0 1 1 0-1.8Z"
        />
    </svg>
)